import $ from 'jquery';
import _ from 'underscore';
import Bowser2 from 'bowser';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Router from 'root/router';
import Tab from 'root/module/tab';
import Modal from 'root/module/modal';
import Modal_Bg from 'root/module/modal_bg';
import Modal_Fullscreen from 'root/module/modal_fullscreen';
import Bottombar from 'root/module/bottombar';
import Sidebar from 'root/module/sidebar';
import Button from 'root/module/button';
import Tooltip from 'root/module/tooltip';
import Form from 'root/module/form';
import View_Menu from 'root/view/menu';
import Modals from 'root/modals';
import Page from 'root/page/base';
import * as Intercom from "@intercom/messenger-js-sdk";

var UI = {
    views: {},

    current_page: null,

    message_duration: 5, // 5 seconds
    messages: {},

    app_container: null,

    overlay: null,

    init: function() {
        this.app_container = $('#app');

        Tab.init();
        Button.init();
        Form.init();
        Tooltip.init();

        this.buildMenu();

        $(document).on('click', 'a.navigation, button.navigation', (e) => {
            e.preventDefault();

            if (Cache.app.app_requires_refresh) {
                window.location = $(e.currentTarget).attr('href');
            } else {
                var href = $(e.currentTarget).attr('href');

                if (href.substr(0, 1) === '?') {
                    href = window.location.pathname + href;
                }

                if (this.onPageUnload('onBeforeUnload', href)) {
                    this.navigateUrl(href);
                }
            }
        });

        $(document).on('click', 'a.popup', function(e) {
            e.preventDefault();

            var width  = $(e.currentTarget).data('width');
            var height = $(e.currentTarget).data('height');

            width  = Math.min(width, $(window).width());
            height = Math.min(height, $(window).height());

            var left = Math.max(0, (screen.availWidth - width) / 2);
            var top  = Math.max(0, (screen.availHeight - height) / 2);
            window.open($(e.currentTarget).attr('href'), 'popup', 'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top);
        })

        if ('ontouchstart' in window) {
            $(document.body).addClass('touch');
        }

        // browser name
        var browser  = Bowser2.getParser(window.navigator.userAgent);
        var browser_name = browser.getBrowserName();
        if (browser_name) {
            $(document.body).attr('data-browser', browser_name.toLowerCase());
        }
    },

    toggleFaviconNotification: function(show) {
        if (show) {
            $('link.system-favicon').attr('href', '/favicon-dot.png');
        } else {
            $('link.system-favicon').attr('href', '/favicon.png');
        }
    },

    setPageTitle: function(title) {
        document.title = title;
    },

    buildMenu: function() {
        if (!this.views.menu && Cache.user) {
            // There's some weird behavior here, this code executes before app/getData is called, and the previous Cache.menu check used to prevent some of the menu code from being rendered here.
            this.views.menu = new View_Menu();
            this.views.menu.render().$el.prependTo(this.app_container);
        }
    },

    getCurrentPage: function() {
        return this.current_page;
    },

    onPageUnload: function(unload_handler, destination_url, change_project) {
        if (this.views.page && this.views.page[unload_handler]) {
            var result = this.views.page[unload_handler]();

            if (result === true) {
                // good to destroy the page
            } else if (typeof result === 'function') {
                if (unload_handler === 'onBeforeUnload') {
                    result(destination_url);
                } else if (unload_handler === 'onBeforeProjectChange') {
                    result(change_project);
                }

                return false;
            } else {
                Modal.open({
                    title: 'Unsaved Changes',
                    content: 'You have unsaved changes. Are you sure you want to leave the page?',
                    button: {
                        'Yes, leave': () => {
                            Modal.close();

                            if (unload_handler === 'onBeforeUnload') {
                                this.navigateUrl(destination_url);
                            } else if (unload_handler === 'onBeforeProjectChange') {
                                change_project();
                            }
                        }
                    },
                    text_link: {
                        Cancel: (e) => {
                            e.preventDefault();
                            Modal.close();
                        }
                    }
                });
                return false;
            }
        }

        return true;
    },

    navigateUrl: function(url) {
        Modal.close();
        Modal_Bg.close();
        Modal_Fullscreen.close();
        Sidebar.close();
        Router.navigate(url, {trigger: true});
    },

    buildPage: async function(page, options, callback) {
        // incomplete onboarding: redirect to /setup/
        if (
            // not login or setup pages
            page !== 'login' && page !== 'setup' &&
            // onboarding is not complete
            Cache.account && Cache.account.get('is_trial') && !Cache.account.get('company') &&
            // is admin user
            Cache.app.isAdmin()) {

            Router.navigate('/setup/', {trigger: true});
            return;
        }

        // users with no project access: redirect to /project/
        if (
            // external pages
            page !== 'login' && page !== 'portal' && page !== 'viewer' && page !== 'sr' && page !== 'capture' &&

            // global pages
            page !== 'project' && page !== 'member' && page !== 'user_segment' && page !== 'session_replay' &&

            // workspace settings (TODO: make them child pages of the workspace_settings page)
            page !== 'account' && page !== 'billing' && page !== 'branding' && page !== 'connected_app' && page !== 'extension_key' && page !== 'api_token' &&

            // setup page
            page !== 'setup' &&

            // 0 projects in the workspace: redirect to the home page
            Cache.real_user_id && Cache.project.where({is_archived: false}).length === 0) {

            Router.navigate('/project/', {trigger: true});
            return;
        }

        // project redirect
        var project_redirects = {
            feedback: {
                'response'           : '/dashboard/',
            },
            survey: {
                'feedback'           : '/dashboard/',
                'feedback_design'    : '/dashboard/',
                'project_workflow'   : '/project/settings',
                'project_automation' : '/project/settings',
                'portal_settings'    : '/project/settings',
                'project_privacy'    : '/project/settings',
            }
        };

        var default_project;

        if (Cache.default_project_id) {
            default_project = Cache.getDefaultProject();

            if (default_project) {
                if (default_project.isFeedback() && project_redirects.feedback[page]) {
                    Router.navigate(project_redirects.feedback[page], {trigger: true});
                    return;
                } else if (default_project.isSurvey() && project_redirects.survey[page]) {
                    Router.navigate(project_redirects.survey[page], {trigger: true});
                    return;
                }
            }
        }

        if (page === 'login' || page === 'setup' || page === 'demo' || page === 'portal' || page === 'viewer' || page === 'sr' || page === 'capture') {
            // no header menu
            if (this.views.menu) {
                this.views.menu.remove();
                this.views.menu = null;
            }
        } else {
            this.buildMenu();
        }

        $(document.body).attr('page', page);
        $(document.body).removeClass('menu-open');

        if (this.isSurveyPage(page) && default_project && default_project.isSurvey()) {
            $('html').attr('data-theme', 'survey');
        } else {
            $('html').removeAttr('data-theme');
        }

        this.current_page = page;

        Cache.app.dispatcher.trigger('UI::build_page', page);

        // destroy old page view
        if (this.views.page && this.views.page.remove) {
            this.views.page.remove();
            this.views.page = null;
            Modal.close();
            Modal_Bg.close();
            Modal_Fullscreen.close();
            Sidebar.close();
            Bottombar.close();
        }

        var page_view;

        if (Page[page]) {
            // lazy load the page
            if (typeof Page[page] === 'string') {
                page_view = (await import(`./page/${Page[page]}`)).default;
            } else {
                page_view = Page[page];
            }
        }

        if (page_view) {
            this.removeMessages();

            $(window).scrollTop(0);

            // wait for window to scroll to the top
            if (page !== 'login' && page !== 'setup' && page !== 'demo' && page !== 'portal' && page !== 'viewer' && page !== 'sr' && page !== 'capture' && page !== 'p') {
                this.views.menu.highlightMenu(page);
            }

            Cache.current_page = page;

            if (options) {
                this.views.page = new page_view(options);
            } else {
                this.views.page = new page_view();
            }

            this.views.page.render();

            this.views.page.$el.appendTo(this.app_container);

            if (page !== 'login' && page !== 'demo' && page !== 'billing' && page !== 'account' && page !== 'referral') { // not login page
                if (!Cache.app.isPublicPage() && !Cache.app.is_admin_login && Cache.account && Cache.account.get('overdue_days') > 0) {  // not in the viewer
                    Modals.warnOverdueInvoice();
                }
            }

            if (this.views.page.onPageReady) {
                var _walk_through = function(views) {
                    if (views && typeof views === 'object') {
                        _.each(views, function(subview, key) {
                            if (subview.onPageReady) {
                                subview.onPageReady.call(subview);
                            } else {
                                _walk_through(subview.views);
                            }
                        });
                    }
                };

                this.views.page.onPageReady.call(this.views.page);
                _walk_through(this.views.page.views);
            }

            if (callback) {
                callback.call(this, this.views.page);
            }

            // mouseleave doesn't fire on document
            // so trigger it manually
            Tooltip.removeAll();
            Tooltip.removeFeatureTip();

            // page message
            var page_message = Router.getQueryString('msg');
            if (page_message) {
                this.success(page_message);
            }

            // scroll to
            var scroll_to = Router.getQueryString('scroll_to');
            if (scroll_to) {
                var scroll_to_options  = scroll_to.split('|');
                var scroll_to_selector = scroll_to_options[0];
                var scroll_to_delay    = scroll_to_options.length === 2 ? scroll_to_options[1] : 0;

                var $scroll_to_element = $('[data-scrollto="' + scroll_to_selector + '"]');
                if ($scroll_to_element.length) {
                    setTimeout(() => {
                        $scroll_to_element.get(0).scrollIntoView();
                    }, scroll_to_delay);
                }
            }
        }

        if (Cache.account && Cache.account.get('is_expired')) {
            // do not show "expired" prompt
            var hidden_pages  = ['login', 'demo'];

            // show "expired" prompt once and allow to close
            var ignored_pages = ['account', 'plan', 'billing', 'referral', 'api_token', 'branding', 'project', 'member', 'connected_app', 'extension_key'];

            if (hidden_pages.indexOf(page) !== -1) {
                // do nothing
            } else if (ignored_pages.indexOf(page) !== -1) {
                Modals.expiredAccount();
            } else {
                if (Cache.app.is_admin_login) {
                    // allow admin login to access the account without redirect to the billing page
                    Modals.expiredAccount();
                } else {
                    if (Cache.app.isAdmin()) {
                        Router.navigate('/account/billing', {trigger: true});
                    } else {
                        Router.navigate('/project/', {trigger: true});
                        Modals.expiredAccount();
                    }
                }
            }
        } else if (Cache.account && Cache.account.isFreePlan() && !Cache.account.get('upgrade_time')) {
            if (['project', 'dashboard'].indexOf(page) !== -1) {
                // show expired trial prompt
                Modals.expiredTrial();
            }
        }
    },

    isSurveyPage: function(page) {
        return ['dashboard', 'response', 'form', 'project_settings', 'project_automation', 'integration', 'ai_assist', 'project_privacy'].indexOf(page) !== -1;
    },

    openLiveChat: function() {
        if (Cache.app.intercom_is_booted) {
            Intercom.show();
            return true;
        }

        window.open('mailto:support@userback.io', '_blank');
        return false;
    },

    // remove all success/error messages
    removeMessages: function() {
        _.each(this.messages, function(message, timeout_id) {
            clearTimeout(timeout_id);
        });

        $('.region-page-message').remove();

        this.messages = {};
    },

    showOverlay: function() {
        if (!this.overlay) {
            this.overlay = $('<div>').addClass('overlay').appendTo($(document.body));
        }
    },

    hideOverlay: function() {
        if (this.overlay === null) {
            return;
        }

        Util.transitionEnd(this.overlay, () => {
            this.overlay.remove();
            this.overlay = null;
        });

        this.overlay.addClass('close');
    },

    success: function(success_message, duration, error, action_button, remove_existing = false, secondary_message = '') {
        if (remove_existing) {
            this.removeMessages();
        }

        duration = duration || this.message_duration;

        var class_name = error ? 'error-message' : 'success-message';
        var icon       = error ? '<i class="fa-regular fa-circle-exclamation"></i>' : '<i class="far fa-check-circle"></i>';

        var message_container = $('.region-page-message').length ? $('.region-page-message') : $('<div>').addClass('region-page-message').appendTo($(document.body));
        var message = $('<div>')
            .addClass(class_name);

        var span = $('<span>').text(success_message);

        message.append(span)
            .prepend(icon).append('<a href="#"><i class="fa-solid fa-xmark"></i></a>')
            .prependTo(message_container);

        if (secondary_message) {
            $('<div>').addClass('secondary-message').text(secondary_message).appendTo(message);
        }

        if (action_button) {
            $('<button>').addClass('small tertiary min').text(action_button.text).on('click', action_button.onclick).appendTo(message);
            message.addClass('has-action');
        }

        var _destroy = () => {
            Util.transitionEnd(message, () => {
                message.remove();
                delete this.messages[timeout_id];

                if (!Object.keys(this.messages).length) {
                    message_container.remove();
                }
            });

            message.addClass('closed');
        };

        message.children('a').on('click', function(e) {
            e.preventDefault();
            _destroy();
        });

        var timeout_id = Cache.app.setTimeout(_destroy, duration * 1000, this);

        this.messages[timeout_id] = message;

        // return updater function
        return (primary_message, secondary_message, hide_action_button) => {
            // message has been removed
            if (!this.messages[timeout_id]) {
                return;
            }

            if (primary_message) {
                message.children('span').text(primary_message);
            }

            if (secondary_message) {
                message.find('.secondary-message').text(secondary_message);
            }

            if (hide_action_button) {
                message.find('button').remove();
            }
        };
    },

    error: function(message, duration) {
        this.success(message, duration, true);
    },

    isMobile: function() {
        var temp_el = $('<div>').addClass('mobile-hidden').css({opacity:0,position:'absolute',top:-999,left:-999}).appendTo('body');
        var is_visible = temp_el.is(':visible');

        temp_el.remove();

        return !is_visible;
    }
};

export default UI;
